import React from 'react';

function EditUpdateIcon({ onClick, dataTestId }: { onClick: () => void; dataTestId: string }) {
  return (
    <svg
      onClick={onClick}
      style={{ marginLeft: '25px' }}
      data-testid={dataTestId}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.1499 19.0002H6.3999L16.6249 8.8002L15.9999 8.1502L15.3499 7.5502L5.1499 17.7752V19.0002ZM3.6499 20.5002V17.1252L16.7999 4.0002C17.0832 3.71686 17.4376 3.5752 17.8629 3.5752C18.2876 3.5752 18.6416 3.71686 18.9249 4.0002L20.1499 5.2502C20.4332 5.53353 20.5749 5.88353 20.5749 6.3002C20.5749 6.71686 20.4332 7.06686 20.1499 7.3502L7.0249 20.5002H3.6499ZM19.0749 6.3002L17.8499 5.0752L19.0749 6.3002ZM16.6249 8.8002L15.9999 8.1502L15.3499 7.5502L16.6249 8.8002Z"
        fill="#9B9BA0"
      />
    </svg>
  );
}

export default EditUpdateIcon;
